var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"the-page-header my-6 flex justify-between items-center",class:{
    'w-full': _vm.isFullWidth
  }},[_c('div',{staticClass:"flex",class:{
      'w-full': _vm.isFullWidth,
      'justify-center text-center': _vm.centered,
      'justify-between': !_vm.centered
    }},[_c('div',{staticClass:"w-full"},[_c('h1',[_vm._t("title"),_vm._t("default")],2),_c('div',{staticClass:"mt-1"},[_vm._t("subtitle")],2)]),_vm._t("action")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }